/**
 * What the server said when a presentation request failed: its status, error code and message, for
 * the end of an error message ("Couldn't create the presentation (500 / Internal server error)").
 * Shown so a failure on staging or production can be traced from what the recruiter sees, without
 * the logs. Null when the error carries none of them (a network failure, for instance).
 */
export function apiErrorReason(error: unknown): string | null {
  const failure = error as { status?: number | string; data?: { error_code?: string; message?: string | string[] } } | null | undefined;
  const message = Array.isArray(failure?.data?.message) ? failure?.data?.message.join(', ') : failure?.data?.message;
  const parts = [failure?.status, failure?.data?.error_code, message].filter((part) => part !== undefined && part !== null && part !== '');
  return parts.length ? parts.join(' / ') : null;
}

/** The message with the server's reason after it, when there is one. Logs the error for the browser console. */
export function withReason(message: string, error: unknown): string {
  // eslint-disable-next-line no-console
  console.error('[presentations]', message, error);
  const reason = apiErrorReason(error);
  return reason ? `${message} (${reason})` : message;
}
